import { IAppProperties } from "@/types";

export interface AppState {
  appProperties: {} | IAppProperties;
}
export default {
  namespaced: true,
  state: {
    appProperties: {
      loadingInvoice: false,
      loadingPayeezyForm: false,
      failedPayeezyFormCreation: false,
      validBillingInfo: true,
      validInvoice: true,
      validParent: true,
      homeMainHTML: "",
      searchHelpHTML: "",
      paymentPlanMaximumMonths: 0,
      paymentPlanQualifyingInvoiceReferencePrefix: "",
      financeEmail: "",
      requestFormVerbiage: "",
      doesNotQualifyVerbiage: "",
      ppSignupConfirmationHTML: ""
    }
  } as AppState,
  getters: {
    getAppProperties: (state: AppState) => state.appProperties
  },
  mutations: {
    SET_APP_PROPERTIES(state: AppState, newAppProperties: IAppProperties) {
      state.appProperties = newAppProperties;
    }
  }
};
